import React from "react";
import styled from '@mui/material/styles/styled';
import { Box } from "@mui/material";
import { DatePicker, DatePickerSlotProps } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const Divider = styled('div')({
    backgroundColor: 'white',
    height: '1px',
    margin: '0 8px',
    width: '12px',
});

const DatePickersContainer = styled(Box)({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
});

interface DatePickersProps {
    fromValue: string | number | null;
    toValue: string | number | null;
    onFromChange: (date: string | number | null | undefined) => void;
    onToChange: (date: number | null) => void;
    slotProps?: DatePickerSlotProps<dayjs.Dayjs, false>;
}

const DatePickers = ({
    fromValue,
    toValue,
    onFromChange,
    onToChange,
    slotProps,
}: DatePickersProps) => {
    const { t } = useTranslation("common");
    const defaultSlotProps: DatePickerSlotProps<dayjs.Dayjs, false> = {
        textField: {
            size: "small",
        },
        ...slotProps,
    };

    return (
        <DatePickersContainer>
            <DatePicker
                label={t("search.filters.from")}
                value={dayjs(fromValue)}
                onChange={(ev) => onFromChange(ev ? ev.valueOf() : null)}
                slotProps={defaultSlotProps}
            />
            <Divider />
            <DatePicker
                label={t("search.filters.to")}
                value={dayjs(toValue)}
                onChange={(ev) => onToChange(ev ? ev.valueOf() : null)}
                slotProps={defaultSlotProps}
            />
        </DatePickersContainer>
    );
};

export default DatePickers;
